// extracted by mini-css-extract-plugin
module.exports = {"AuthNavigationBox":"AuthNavigation_AuthNavigationBox__qgGBG","authNav":"AuthNavigation_authNav__1tubr","activeNav":"AuthNavigation_activeNav__3Pxvj"};